<template>
  <cv-content id="main-content" style="max-width: 1200px;">
    <cv-grid full-Width>
      <cv-row>
        <cv-column :sm="0" :md="0" :lg="16">
          <cv-text-input label="Descrizione" title="Descrizione"
                         value="BIETOLE" style="width: 58rem;"/>
        </cv-column>
        <cv-column :sm="4" :md="8" :lg="0">
          <cv-text-input label="Descrizione" title="Descrizione"
                         value="BIETOLE" />
        </cv-column>
      </cv-row>
    </cv-grid>
    <hr/>
    <Bottoniera testo_nuovo="Nuova Coltura"
                testo_salva="Salva Coltura"
                :stato="this.$statiPossibili.non_modificato"
                v-on:salva-premuto="$emit('bottone-premuto')"
                v-on:nuovo-premuto="$emit('bottone-premuto')"
                v-on:duplica-premuto="$emit('bottone-premuto')"
                v-on:primo-premuto="$emit('bottone-premuto')"
                v-on:precedente-premuto="$emit('bottone-premuto')"
                v-on:successivo-premuto="$emit('bottone-premuto')"
                v-on:ultimo-premuto="$emit('bottone-premuto')"
                v-on:visualizzazione-premuto="$emit('bottone-premuto')"
                v-on:filtra-premuto="$emit('bottone-premuto')"
                v-on:cancella-premuto="$emit('bottone-premuto')" />
  </cv-content>
</template>

<script>
import Bottoniera from "@/components/Bottoniera";

export default {
  name: "Colture",
  components: { Bottoniera }
}
</script>

<style scoped>

</style>